import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { DealStatusFindInterface } from '@zaoblako/shared/modules/business/dto/deal-status/deal-status-find.dto';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Deals group create or update request body */
export interface DealsGroupFormInterface {
  /** Group display name */
  name: string;
  /** Deal status to assign */
  status?: DealStatusFindInterface;
  /** User auditors (deals group participants) */
  userAuditors?: UserFindInterface[];
  /** Group auditors (deals group participants) */
  groupAuditors?: UserGroupFindInterface[];
  /** Deals included in this group */
  deals?: DealFindInterface[];
}

/** Deals group create or update request body - DTO schema */
export const DealsGroupFormDto = SerdeDtoClass.create<DealsGroupFormInterface>(BusinessDtoKeysEnum.DEALS_GROUP_FORM_DTO, {
  name: {
    label: 'Имя',
    serializer: yup.string().required(DtoMessageEnum.EMPTY_STRING),
  },
  status: {
    optional: true,
    label: 'Статус',
    serializer: entityLikeSchema,
  },
  userAuditors: {
    optional: true,
    label: 'Номера аудиторов',
    serializer: yup.array(entityLikeSchema),
  },
  groupAuditors: {
    optional: true,
    label: 'Номера групп аудиторов',
    serializer: yup.array(entityLikeSchema),
  },
  deals: {
    optional: true,
    label: 'Номера сделок',
    serializer: yup.array(entityLikeSchema),
  },
});
